import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["typescript"];
import { parseAsEstree } from "./parse";
import { precook } from "./precook";
export function precookFunction(source) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    {
      typescript
    } = _ref,
    restOptions = _objectWithoutProperties(_ref, _excluded);
  var func = parseAsEstree(source, {
    typescript
  });
  var attemptToVisitGlobals = precook(func, restOptions);
  return {
    function: func,
    attemptToVisitGlobals
  };
}
//# sourceMappingURL=precookFunction.js.map